import default_logo from '../theme/rh-logo-comp.png';
import st_logo from '../theme/stresidences-logo.png';
import sands_logo from '../theme/sands.jpg';
import youarehome_logo from '../theme/youarehome.png';
import clarendon_logo from '../theme/clarendon-logo.png';
import signet_logo from '../theme/signet.png';
import charmstay_logo from '../theme/charm_stay.png';
import citystay_logo from '../theme/city-stay.png';
import roomspace_logo from '../theme/room-space.png';
import scandik_logo from '../theme/scandik_logo.png';
import kepplestone_logo from '../theme/kepplestone-logo.png';
import bnbme_logo from '../theme/bnbme-logo.jpg';
import cosmo_logo from '../theme/cosmo_logo.png';
import tempstay_logo from '../theme/tempstay-logo.png';
import tjpad_logo from '../theme/tjpad-logo.png';
import sixstays_logo from '../theme/sixstays-logo.jpg';
import flyingbutler_logo from '../theme/flyingbutler-logo.png';
import zomelle_logo from '../theme/zomelle-logo.png';
import buckinghamandlloyds_logo from '../theme/buckinghamandlloyds-logo.png';
import domusstay_logo from '../theme/domusstay-logo.jpg';
import qapartments_logo from '../theme/qapartments-logo.png';
import markeygroup_logo from '../theme/markeygroup-logo.jpeg';
import week2week_logo from '../theme/week2week-logo.jpg';
import homenhancement_logo from '../theme/homenhancement-logo.svg';
import thecollective_logo from '../theme/thecollective-logo.png';

const logos = {
	default: default_logo,
	stresidences: st_logo,
	escape2thesands: sands_logo,
	youarehome: youarehome_logo,
	clarendon: clarendon_logo,
	signetapartments: signet_logo,
	charmstay: charmstay_logo,
	citystayapartment: citystay_logo,
	roomspace: roomspace_logo,
	scandik: scandik_logo,
	kepplestonemanor: kepplestone_logo,
	bnbme: bnbme_logo,
	cosmopolitanapartments: cosmo_logo,
	tempstay: tempstay_logo,
	tjpad: tjpad_logo,
	sixstays: sixstays_logo,
	flyingbutler: flyingbutler_logo,
	zomelle: zomelle_logo,
	buckinghamandlloyds: buckinghamandlloyds_logo,
	domusstay: domusstay_logo,
	qapartments: qapartments_logo,
	markeygroup: markeygroup_logo,
	week2week: week2week_logo,
	homenhancement: homenhancement_logo,
	thecollective: thecollective_logo,
	citywestaparthotel: default_logo,
	khhomes: default_logo,
	basilstreetapartments: default_logo,
	briscoeandshaw: default_logo,

};

export default function (env) {
	if(logos[env] !== undefined) {
		return logos[env];
	}
	return logos.default;
}
